import routes from "@/routers/routes";
import PageHeader from "@/app/shared/page-header";
import CustomerProfile from "@/app/shared/orders/customer-profile";
import EditProfileButton from "@/app/shared/orders/customer-profile/edit-profile";
import { metaObject } from "@/config/site.config";
import {
    fetchClientById,
    fetchCustomerOrders,
    fetchOrders,
} from "@/server/api-services";
import { Client, Order, OrderStatus } from "@/types";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export const metadata = {
    ...metaObject("Customer Profile"),
};

const pageHeader = {
    title: "Customer Profile",
    breadcrumb: [
        {
            href: routes.eCommerce.dashboard,
            name: "Dashboard",
        },
        {
            href: routes.orders.dashboard,
            name: "Logistics",
        },
        {
            name: "Customer Profile",
        },
    ],
};

export default function CustomerProfilePage() {
    const { id } = useParams();

    const [client, setClient] = useState<Client>({} as Client);

    const [orders, setOrders] = useState<Order[]>([]);

    useEffect(() => {
        if (id) {
            loadOrders();
            getClient();
        }
    }, [id]);

    async function getClient() {
        const response = await fetchClientById(id as string);

        if (response.statusCode !== 200) {
            return;
        }

        setClient(response.data as Client);
    }

    async function loadOrders() {
        const response = await fetchCustomerOrders(id as string);

        if (response.statusCode !== 200) {
            return;
        }

        var data = response.data as Order[];

        data = data.map((order) => ({
            ...order,
            status: OrderStatus[order.status as keyof typeof OrderStatus],
        }));

        setOrders(data);
    }

    return (
        <>
            <PageHeader
                title={pageHeader.title}
                breadcrumb={pageHeader.breadcrumb}
            >
                <EditProfileButton className="mt-5 md:mt-0" />
            </PageHeader>

            <CustomerProfile client={client} orders={orders} />
        </>
    );
}
